import { useMemo } from 'react';
import { useIsAutorizedUser, useIsMapsRegional } from 'store/features/auth';

export const useShowCarTypeSelect = () => {
  const isAutorizedUser = useIsAutorizedUser();
  const isMapsRegional = useIsMapsRegional();

  return useMemo(() => ({
    showInBuildingRouteFilter: isAutorizedUser && !isMapsRegional
  }), [isAutorizedUser, isMapsRegional]);
};
